import React, { useState, useEffect, useMemo } from "react";

import { motion } from 'framer-motion';
import bag1 from './img/bag1.png';
import bag2 from './img/bag2.png';
import bag3 from './img/bag3.png';
import backg1 from './img/bg1.png';
import backg2 from './img/bg2.png';
import cap from './img/cap.png';
import doll from './img/doll.png';
import backg3 from './img/bg3.png';
import backg4 from './img/bg4.png';
import {
  ShoppingBag,
  Heart,
  MessageCircle,
  Menu,
  X,
  Star,
  CheckCircle,
  Truck,
  ShieldCheck,
  ChevronRight,
  Minus,
  Plus,
  Info,
  CreditCard,
  Instagram,
  Twitter,
  Facebook,
  Package,
  User,
  Search,
  MapPin,
  ChevronDown,
  ShoppingCart,
  Clock,
  Phone,
  Mail,
  HelpCircle,
  ShieldAlert,
  LogOut,
  ExternalLink,
  ChevronLeft,
  CreditCard as CardIcon,
  Smartphone,
} from "lucide-react";

// --- MOCK DATA ---
const PRODUCTS = [
  {
    id: 1,
    name: "Autumn Rose Tote",
    price: 189,
    oldPrice: 220,
    category: "Bags",
    rating: 5,
    color: "#E9967A",
    image: bag1,
    desc: "Organic cotton with gold-thread accents.",
    stock: 5,
  },
  {
    id: 2,
    name: "Seafoam Shell Bag",
    price: 299,
    oldPrice: 315,
    category: "Bags",
    rating: 4.8,
    color: "#20B2AA",
    image: bag2,
    desc: "Inspired by the Amalfi coast textures.",
    stock: 12,
  },
  {
    id: 3,
    name: "Boho Fringe Bag",
    price: 475,
    oldPrice: 590,
    category: "Bags",
    rating: 4.9,
    color: "#D2B48C",
    image: bag3,
    desc: "Hand-knotted fringe for evening elegance.",
    stock: 8,
  },
  {
    id: 4,
    name: "Cozy Winter Cap",
    price: 445,
    oldPrice: 455,
    category: "Caps",
    rating: 5,
    color: "#708090",
    image: cap,
    desc: "Double-layered for mountain warmth.",
    stock: 20,
  },
  {
    id: 5,
    name: "Bella the doll",
    price: 620,
    oldPrice: 750,
    category: "Dolls",
    rating: 5,
    color: "#FFB6C1",
    image: doll,
    desc: "Hypoallergenic yarn safe for toddlers.",
    stock: 3,
  },
  // {
  //   id: 6,
  //   name: "Lulu the Bunny",
  //   price: 110,
  //   oldPrice: 130,
  //   category: "Dolls",
  //   rating: 4.7,
  //   color: "#F0E68C",
  //   image: bag1,
  //   desc: "Stitched with over 4,000 unique loops.",
  //   stock: 4,
  // },
  // {
  //   id: 7,
  //   name: "Golden Honey Scarf",
  //   price: 65,
  //   oldPrice: 85,
  //   category: "Other",
  //   rating: 4.9,
  //   color: "#FFD700",
  //   image: bag1,
  //   desc: "Hand-spun silk blend.",
  //   stock: 15,
  // },
  // {
  //   id: 8,
  //   name: "Cloud Knit Throw",
  //   price: 180,
  //   oldPrice: 220,
  //   category: "Other",
  //   rating: 5,
  //   color: "#F5F5F5",
  //   image: bag1,
  //   desc: "Chunky knit for luxury living.",
  //   stock: 2,
  // },
];

const INR = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
});

const CATEGORIES = ["All", "Bags", "Caps", "Dolls", "Other"];

export default function App() {

  const [activePage, setActivePage] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [notification, setNotification] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

 
  const [checkoutStep, setCheckoutStep] = useState(1); // 1: Address, 2: Payment, 3: Card Details, 4: Success
  const [selectedPayment, setSelectedPayment] = useState("");
  const [editData, setEditData] = useState(null);


  const [cart, setCart] = useState(() =>
    JSON.parse(localStorage.getItem("cb_cart") || "[]")
  );
  const [wishlist, setWishlist] = useState(() =>
    JSON.parse(localStorage.getItem("cb_wishlist") || "[]")
  );
  const [orders, setOrders] = useState(() =>
    JSON.parse(localStorage.getItem("cb_orders") || "[]")
  );

  const [selectedProduct, setSelectedProduct] = useState(null);
  const similarProducts = useMemo(
    () =>
      PRODUCTS.filter(
        (p) =>
          p.category === selectedProduct?.category &&
          p.id !== selectedProduct?.id
      ).slice(0, 4),
    [selectedProduct]
  );


  const [address, setAddress] = useState({
    name: "John Doe",
    street: "123 Artisan Way",
    city: "Florence",
    zip: "50100",
    country: "Italy",
  });
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  const [user, setUser] = useState(null);

  const [editing, setEditing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [subscriberEmail, setSubscriberEmail] = useState("");

  const [termsPage, setTermsPage] = useState(false);
  const [sustainabilityPage, setSustainabilityPage] = useState(false);
  const [cookiesPage, setCookiesPage] = useState(false);

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [otp, setOtp] = useState("");


  useEffect(() => {
    if (activePage === "profile" && user) {
      setEditData({
        name: user.name || "",
        bio: user.bio || "",
        phone: user.phone || "",
        street: user.address?.street || "",
        city: user.address?.city || "",
        accountNumber: user.bankDetails?.accountNumber || "",
        ifsc: user.bankDetails?.ifsc || "",
      });
    }
  }, [activePage, user]);

  useEffect(
    () => localStorage.setItem("cb_user", JSON.stringify(user)),
    [user]
  );
  useEffect(
    () => localStorage.setItem("cb_cart", JSON.stringify(cart)),
    [cart]
  );
  useEffect(
    () => localStorage.setItem("cb_wishlist", JSON.stringify(wishlist)),
    [wishlist]
  );
  useEffect(
    () => localStorage.setItem("cb_orders", JSON.stringify(orders)),
    [orders]
  );


  const subtotal = useMemo(
    () => cart.reduce((t, i) => t + i.price * i.qty, 0),
    [cart]
  );



  const navigate = (page) => {
    setActivePage(page);
    setIsMenuOpen(false);
    setIsCartOpen(false);
    window.scrollTo(0, 0);
  };

  const addToCart = (p) => {
    setCart((prev) => {
      const exists = prev.find((i) => i.id === p.id);
      if (exists)
        return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { ...p, qty: 1 }];
    });
  };


  const toggleWishlist = (p) => {
    setWishlist((prev) => {
      const exists = prev.find((i) => i.id === p.id);
      if (exists) {
        return prev.filter((i) => i.id !== p.id);
      }
      return [...prev, p];
    });
  };

  const showNotification = (msg) => {
    alert(msg);
  };


  const saveProfile = () => {
    setUser({
      ...user,
      name: editData.name,
      bio: editData.bio,
      phone: editData.phone,
      address: {
        street: editData.street,
        city: editData.city,
      },
      bankDetails: {
        accountNumber: editData.accountNumber,
        ifsc: editData.ifsc,
      },
    });
    setEditing(false);
  };

 

  // ===== Send OTP =====
  const handleSendOtp = async () => {
    try {
      const res = await fetch("http://localhost:3000/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) return alert(data.message);

      alert("OTP sent to your email!");
      setStep(2);
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  

  const handleVerifyOtp = async () => {
    try {
      const res = await fetch("http://localhost:3000/api/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, otp }),
      });

      const data = await res.json();
      console.log("VERIFY RESPONSE:", data);
      if (!res.ok) return alert(data.message);

      setUser(data.user);
      // Instead of setStep(3), navigate to home
      setActivePage("home");
      alert("Login successful!");
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  // Save Address
  const saveAddress = async () => {
    setIsEditingAddress(false);
    setUser((prev) => ({ ...prev, address }));
 
    await fetch(`http://localhost:3000/api/user/${user.email}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...user, address }),
    });
  };

  // Place Order
  const placeOrder = async () => {
    if (!user.address) return alert("Please add address first");

    const orderPayload = {
      user,
      cart,
      total: subtotal,
    };

    const res = await fetch("http://localhost:3000/api/order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderPayload),
    });

    const data = await res.json();

    if (!res.ok) return alert(data.message);

    setCheckoutStep(4);
  };

  const handleSubscribe = async () => {
    if (!subscriberEmail) {
      alert("Please enter your email!");
      return;
    }

    try {
      const res = await fetch("http://localhost:3000/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: subscriberEmail }),
      });

      const data = await res.json();

      if (res.ok) {
        setSubscribed(true);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
    }
  };

  const handleCheckout = () => {
    if (!user) {
      navigate("login");
      showNotification("Please login to continue");
      return;
    }
    setCheckoutStep(1);
    setIsCartOpen(false);
    setActivePage("checkout");
  };

 

  // Components
  const ProductCard = ({ p, onProductClick }) => (
    
    <motion.div
      className="group bg-white rounded-xl shadow-sm border border-gray-100 flex flex-col cursor-pointer overflow-hidden"
      onClick={() => onProductClick?.(p)}
      whileHover={{ y: -8, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <div
        className="relative aspect-square overflow-hidden bg-gray-50 flex items-center justify-center"
        
      >
        {/* <div className="w-full h-full flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
          <ShoppingBag
            size={80}
            style={{ color: p.color }}
            className="opacity-40"
          />
        </div> */}
        <img
          src={p.image}
          alt={p.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleWishlist(p);
          }}
          className="absolute top-3 right-3 p-2 bg-white/80 backdrop-blur rounded-full shadow-sm hover:bg-white transition-colors"
        >
          <Heart
            size={18}
            className={
              wishlist.find((i) => i.id === p.id)
                ? "text-red-500 fill-current"
                : "text-gray-400"
            }
          />
        </button>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex justify-between items-start mb-1">
          <h3 className="font-bold text-gray-800 text-sm line-clamp-1">
            {p.name}
          </h3>
          <span className="text-xs font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded">
            In Stock
          </span>
        </div>
        <div className="flex items-center gap-1 mb-3">
          <Star size={12} className="text-pink-400 fill-current" />
          <span className="text-xs font-bold text-gray-500">
            {p.rating} (42)
          </span>
        </div>
        <div className="mt-auto flex items-center justify-between">
          <div>
            <span className="text-lg font-black text-gray-900">
              {INR.format(p.price)}
            </span>
            <span className="text-xs text-gray-400 line-through ml-2">
              {INR.format(p.oldPrice)}
            </span>
          </div>
          <button
            onClick={() => addToCart(p)}
            className="p-2 bg-slate-900 text-white rounded-lg hover:bg-pink-500 transition-colors"
          >
            <Plus size={18} />
          </button>
        </div>
      </div>
    </motion.div>
  );

  return (
    <div
      className="min-h-screen bg-gray-50 text-slate-900
      [font-size:1.1rem]
      font-['Inter',sans-serif]
      antialiased
      selection:bg-pink-100"
    >
      <style>{`
        @keyframes slideIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
        .animate-slide { animation: slideIn 0.3s ease-out; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
      `}</style>

      {/* Floating Notification */}
      {notification && (
        <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[100] bg-slate-900 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-3 animate-bounce">
          <CheckCircle className="text-pink-500" size={18} />
          <span className="text-sm font-bold">{notification}</span>
        </div>
      )}

      {/* Navigation Header */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsMenuOpen(true)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <Menu size={24} />
            </button>
            <div
              className="text-2xl font-black tracking-tighter cursor-pointer select-none"
              onClick={() => navigate("home")}
            >
              CROCHET<span className="text-pink-500">BEEE</span>
            </div>
          </div>

          {/* <div className="hidden md:flex flex-1 max-w-xl relative">
            <input
              type="text"
              placeholder="Search unique hand-knitted luxury..."
              className="w-full bg-gray-100 border-none rounded-xl py-3 pl-12 pr-4 focus:ring-2 focus:ring-pink-500 transition-all outline-none"
            />
            <Search
              className="absolute left-4 top-3.5 text-gray-400"
              size={20}
            />
          </div> */}

          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center text-pink-600 font-bold">
              {user?.name ? user.name[0] : <User size={18} />}
            </div>
            <div className="text-left leading-none">
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">
                Account
              </p>
              <p className="text-xs font-black">
                {user?.name ? user.name.split(" ")[0] : "Sign In"}
              </p>
            </div>
            {/* <button
              onClick={() => navigate("profile")}
              className="hidden sm:flex items-center gap-2 p-2 hover:bg-gray-100 rounded-xl transition-colors"
            >
            </button> */}
            <button
              onClick={() => setIsCartOpen(true)}
              className="relative p-3 bg-slate-900 text-white rounded-xl hover:bg-pink-500 transition-all shadow-lg hover:shadow-pink-200"
            >
              <ShoppingBag size={20} />
              {cart.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-white text-pink-600 text-[10px] font-black w-5 h-5 rounded-full flex items-center justify-center shadow-md">
                  {cart.reduce((a, b) => a + b.qty, 0)}
                </span>
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Main Sidebar Menu */}
      <div
        className={`fixed inset-0 z-[100] transition-opacity duration-300 ${
          isMenuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
          onClick={() => setIsMenuOpen(false)}
        />
        <aside
          className={`absolute inset-y-0 left-0 w-80 bg-white shadow-2xl transition-transform duration-300 flex flex-col ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="p-6 border-b flex items-center justify-between flex-shrink-0">
            <div className="font-black text-xl">MENU</div>
            <X
              className="cursor-pointer text-gray-400"
              onClick={() => setIsMenuOpen(false)}
            />
          </div>
          <div className="p-4 space-y-1 flex-1 overflow-y-auto">
            {!user ? (
              <button
                onClick={() => {
                  navigate("login");
                  setIsMenuOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-pink-50 text-pink-600 rounded-xl font-bold mb-4"
              >
                <User size={20} /> Sign In / Login
              </button>
            ) : (
              <div className="p-4 bg-gray-50 rounded-xl mb-4">
                <p className="text-xs text-gray-400 font-bold uppercase">
                  Welcome back
                </p>
                <p className="font-black text-lg">{user.name || "User"}</p>
                {/* <button
                  onClick={() => navigate("profile")}
                  className="text-xs text-pink-600 font-bold mt-1"
                >
                  View Profile
                </button> */}
              </div>
            )}

            <div className="py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest pl-4">
              Shop By Category
            </div>
            {CATEGORIES.slice(1).map((cat) => (
              <button
                key={cat}
                onClick={() => {
                  setCategoryFilter(cat);
                  navigate("home");
                }}
                className="w-full flex items-center justify-between p-4 hover:bg-gray-50 rounded-xl transition-colors text-sm font-bold"
              >
                {cat} <ChevronRight size={16} className="text-gray-300" />
              </button>
            ))}

            <div className="my-4 border-t border-gray-100" />

            <button
              onClick={() => navigate("wishlist")}
              className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl text-sm font-bold"
            >
              <Heart size={20} className="text-red-500" /> My Wishlist
            </button>
            <button
              onClick={() => navigate("orders")}
              className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl text-sm font-bold"
            >
              <Package size={20} className="text-blue-500" /> Order History
            </button>
            <button
              onClick={() => navigate("help")}
              className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl text-sm font-bold"
            >
              <HelpCircle size={20} className="text-green-500" /> Customer
              Service
            </button>
            <button
              onClick={() => navigate("shipping")}
              className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl text-sm font-bold"
            >
              <Truck size={20} className="text-purple-500" /> Shipping Policies
            </button>
            <button
              onClick={() => navigate("privacy")}
              className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl text-sm font-bold"
            >
              <ShieldAlert size={20} className="text-amber-500" /> Privacy
              Policy
            </button>

            {user && (
              <button
                onClick={() => {
                  setUser(null);
                  localStorage.removeItem("cb_user");
                  setActivePage("home");
                  setIsMenuOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 text-red-500 hover:bg-red-50 rounded-xl text-sm font-bold mt-4"
              >
                <LogOut size={20} /> Logout
              </button>
            )}
          </div>
        </aside>
      </div>

      {/* Cart Sidebar */}
      <div
        className={`fixed inset-0 z-[100] transition-opacity duration-300 ${
          isCartOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
          onClick={() => setIsCartOpen(false)}
        />
        <aside
          className={`absolute inset-y-0 right-0 w-full sm:w-96 bg-white shadow-2xl transition-transform duration-300 ${
            isCartOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="p-6 border-b flex items-center justify-between">
            <h2 className="font-black text-xl">YOUR BASKET</h2>
            <X
              className="cursor-pointer"
              onClick={() => setIsCartOpen(false)}
            />
          </div>
          <div className="flex-1 overflow-y-auto p-6 no-scrollbar h-[calc(100vh-250px)]">
            {cart.length === 0 ? (
              <div className="h-full flex flex-col items-center justify-center text-center">
                <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                  <ShoppingBag className="text-gray-200" size={40} />
                </div>
                <p className="font-bold text-gray-400">Your basket is empty</p>
                <button
                  onClick={() => setIsCartOpen(false)}
                  className="text-pink-600 font-bold mt-2 hover:underline"
                >
                  Start Shopping
                </button>
              </div>
            ) : (
              <div className="space-y-6">
                {cart.map((item) => (
                  <div key={item.id} className="flex gap-4">
                    {/* <div
                      className="w-20 h-20 rounded-xl bg-gray-100 flex-shrink-0"
                      style={{ backgroundColor: `${item.color}30` }}
                    ></div> */}
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-20 h-20 rounded-xl object-cover flex-shrink-0"
                    />

                    <div className="flex-1">
                      <p className="text-sm font-black">{item.name}</p>
                      <p className="text-pink-600 font-black">
                        {INR.format(item.price)}
                      </p>
                      <div className="flex items-center justify-between mt-2">
                        <div className="flex items-center gap-3 bg-gray-100 rounded-lg px-2">
                          <button
                            onClick={() =>
                              setCart(
                                cart.map((i) =>
                                  i.id === item.id
                                    ? { ...i, qty: Math.max(1, i.qty - 1) }
                                    : i
                                )
                              )
                            }
                            className="p-1"
                          >
                            <Minus size={12} />
                          </button>
                          <span className="text-xs font-bold w-4 text-center">
                            {item.qty}
                          </span>
                          <button
                            onClick={() =>
                              setCart(
                                cart.map((i) =>
                                  i.id === item.id
                                    ? { ...i, qty: i.qty + 1 }
                                    : i
                                )
                              )
                            }
                            className="p-1"
                          >
                            <Plus size={12} />
                          </button>
                        </div>
                        <button
                          onClick={() =>
                            setCart(cart.filter((i) => i.id !== item.id))
                          }
                          className="text-[10px] font-bold text-red-400 uppercase tracking-widest"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="p-6 border-t bg-gray-50">
            <div className="flex justify-between items-center mb-4">
              <span className="font-bold text-gray-500">Subtotal</span>
              <span className="text-2xl font-black">
                {INR.format(subtotal)}
              </span>
            </div>
            <button
              disabled={cart.length === 0}
              onClick={handleCheckout}
              className="w-full bg-slate-900 text-white py-4 rounded-xl font-black text-lg shadow-xl shadow-slate-200 hover:bg-pink-600 transition-all disabled:opacity-50"
            >
              SECURE CHECKOUT
            </button>
            <p className="text-[10px] text-center text-gray-400 mt-4 uppercase tracking-widest font-bold">
              Free global shipping on luxury items
            </p>
          </div>
        </aside>
      </div>

      {/* PAGE CONTENT */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* HOME PAGE */}
        {activePage === "home" && (
          <div className="space-y-16">
            {/* Hero / Header Section */}
            <section className="relative h-[400px] rounded-3xl overflow-hidden group">
              <div className="absolute inset-0 bg-slate-900">
                <img
                  src={backg1}
                  alt="background"
                  className="w-full h-full object-cover opacity-60 transition-transform duration-1000 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex flex-col justify-end p-8 md:p-12">
                <h1 className="text-4xl md:text-6xl font-black text-white leading-none mb-4">
                  Stitched by Heart, Woven for
                  <br />
                  <span className="text-pink-500">Soul</span>
                </h1>

                <p className="text-gray-300 max-w-md text-sm md:text-base mb-8">
                  Exclusive hand-knotted collections from the world's finest
                  weavers. Sustainable, rare, and personal.
                </p>
                <div className="flex gap-4">
                  <button
                    onClick={() => setCategoryFilter("Bags")}
                    className="bg-white text-slate-900 px-8 py-3 rounded-full font-black text-sm hover:bg-pink-500 hover:text-white transition-all shadow-xl"
                  >
                    Shop Bags
                  </button>
                  <button
                    onClick={() => navigate("help")}
                    className="bg-white/20 backdrop-blur text-white px-8 py-3 rounded-full font-black text-sm border border-white/30"
                  >
                    Learn More
                  </button>
                  <button
                    onClick={() => setActivePage("quiz")}
                    className="self-start bg-white text-slate-900 px-8 py-3 rounded-full font-black text-sm hover:bg-pink-500 hover:text-white transition-all shadow-xl"
                  >
                    Discover My Style
                  </button>
                </div>
              </div>
            </section>

            <div className="absolute top-8 left-8 bg-white/90 backdrop-blur px-6 py-3 rounded-2xl text-sm">
              🔥 6 Handmade Bags Ready to Ship Today
            </div>

            {/* Collections & Filters */}
            <section id="collections">
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8">
                <div>
                  <h2 className="text-3xl font-black uppercase tracking-tighter">
                    Our Collections
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    Filtered by {categoryFilter}
                  </p>
                </div>

                <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar">
                  {CATEGORIES.map((cat) => (
                    <button
                      key={cat}
                      onClick={() => setCategoryFilter(cat)}
                      className={`px-6 py-2 rounded-full text-xs font-black transition-all border whitespace-nowrap ${
                        categoryFilter === cat
                          ? "bg-slate-900 text-white border-slate-900 shadow-lg"
                          : "bg-white text-gray-500 border-gray-200 hover:border-slate-900"
                      }`}
                    >
                      {cat.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>
              {(() => {
                const userStyle = localStorage.getItem("userStyle");
                return (
                  userStyle && (
                    <div className="w-full sm:w-auto px-3 py-2 bg-pink-500/15 border border-pink-500/40 text-pink-500 text-xs sm:text-sm font-bold rounded-full mb-4 md:mb-0 shadow-lg">
                      👋{" "}
                      {userStyle === "boho"
                        ? "Boho Collection"
                        : "Minimal Picks"}{" "}
                      for you
                    </div>
                  )
                );
              })()}

              <br />
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {PRODUCTS.filter(
                  (p) =>
                    categoryFilter === "All" || p.category === categoryFilter
                ).map((p) => (
                  <ProductCard
                    key={p.id}
                    p={p}
                    onProductClick={() => setSelectedProduct(p)}
                  />
                ))}

                {/* {PRODUCTS.filter(
                  (p) =>
                    categoryFilter === "All" || p.category === categoryFilter
                ).map((p) => (
                  <div
                    key={p.id}
                    className="group cursor-pointer"
                    onClick={() => setSelectedProduct(p)}
                    // style={{
                    //   backgroundImage: `url(${p.image})`,
                    //   backgroundSize: "cover",
                    //   backgroundPosition: "center",
                    // }}
                    // <ProductCard
                    //   key={p.id}
                    //   p={p}
                    //   onProductClick={() => setSelectedProduct(p)}
                    // />
                  >
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                  <h4 className="font-bold text-sm mt-2">{p.name}</h4>
                  <p className="text-pink-600 font-black">{INR.format(p.price)}</p>
                  </div>
                ))} */}
              </div>
            </section>

            {/* Best Selling */}
            <section className="bg-white p-10 rounded-3xl border border-gray-100">
              <div className="text-center max-w-2xl mx-auto mb-12">
                <h2 className="text-3xl font-black mb-2">BEST SELLERS</h2>
                <div className="w-12 h-1 bg-pink-500 mx-auto rounded-full mb-4"></div>
                <p className="text-gray-500 text-sm">
                  Our community's favorite luxury pieces, verified by thousands
                  of satisfied customers.
                </p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                {PRODUCTS.slice(0, 4).map((p) => (
                  <div
                    className="text-center group cursor-pointer"
                    onClick={() => setSelectedProduct(p)}
                  >
                    <div className="aspect-square rounded-2xl bg-gray-50 mb-4 flex items-center justify-center relative overflow-hidden">
                      {/* <ShoppingBag
                        size={48}
                        style={{ color: p.color }}
                        className="opacity-20 group-hover:scale-110 transition-transform"
                      /> */}
                      <img
                        src={p.image}
                        alt={p.name}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/10 transition-colors" />
                    </div>
                    <h4 className="font-bold text-sm mb-1">{p.name}</h4>
                    <p className="text-pink-600 font-black">
                      {INR.format(p.price)}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* About Page Section */}
            <section className="grid md:grid-cols-2 gap-12 items-center py-10">
              <div className="relative">
                <div className="aspect-[5/5] bg-gray-200 rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src={backg2}
                    alt="background"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl max-w-xs hidden sm:block">
                  <p className="text-xs text-gray-500 font-bold uppercase mb-2">
                    Our Quality Promise
                  </p>
                  <p className="text-sm font-medium italic">
                    "Each piece is woven with a single continuous thread,
                    symbolizing the connection between artisan and wearer."
                  </p>
                </div>
              </div>
              <div className="space-y-6">
                <h2 className="text-4xl font-black leading-tight">
                  WEAVING STORIES
                  <br />
                  STITCH BY STITCH
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  Founded in the heart of Florence, CrochetBeee Luxury began as
                  a small collective of master weavers. Today, we bridge the gap
                  between ancient heritage and modern luxury.
                </p>
                <div className="space-y-4">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center text-pink-600 flex-shrink-0">
                      <ShieldCheck />
                    </div>
                    <div>
                      <p className="font-bold">100% Organic Materials</p>
                      <p className="text-sm text-gray-500">
                        Sustainably sourced GOTS cotton and silk blends.
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 flex-shrink-0">
                      <Truck />
                    </div>
                    <div>
                      <p className="font-bold">Artisan Direct Shipping</p>
                      <p className="text-sm text-gray-500">
                        Shipped from the weaver's hands directly to yours.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <button className="text-pink-600 font-black flex items-center gap-2 group">
                  Explore Our Heritage{" "}
                  <ChevronRight
                    size={20}
                    className="group-hover:translate-x-1 transition-transform"
                  />
                </button> */}
                <button
                  onClick={() => setActivePage("heritage")}
                  className="text-pink-600 font-black flex items-center gap-2 group"
                >
                  Explore Our Heritage{" "}
                  <ChevronRight
                    size={20}
                    className="group-hover:translate-x-1 transition-transform"
                  />
                </button>
              </div>
            </section>

            {/* Join Community / Subscribe */}
            {/* <section className="bg-slate-900 rounded-3xl p-12 text-center text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500 rounded-full blur-[120px] opacity-20 -translate-y-1/2 translate-x-1/2"></div>
              <h2 className="text-3xl font-black mb-4">JOIN THE COLLECTIVE</h2>
              <p className="text-gray-400 max-w-lg mx-auto mb-8 font-medium">
                Receive exclusive access to new drops, artisan stories, and a
                10% discount on your first luxury order.
              </p>
              <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="bg-white/10 border border-white/20 rounded-xl px-6 py-4 flex-1 outline-none focus:ring-2 focus:ring-pink-500"
                />
                <button className="bg-pink-500 text-white font-black px-8 py-4 rounded-xl hover:bg-pink-600 transition-colors shadow-xl">
                  SUBSCRIBE
                </button>
              </div>
            </section> */}

            {/* Join Community / Subscribe */}
            <section className="bg-slate-900 rounded-3xl p-12 text-center text-white relative overflow-hidden">
              {/* <div className="absolute top-8 right-8 bg-white/10 backdrop-blur-lg rounded-2xl px-6 py-3">
                <div className="text-2xl font-black text-white">47</div>
                <div className="text-xs uppercase tracking-wider text-white/80">
                  Trees Saved
                </div>
              </div> */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500 rounded-full blur-[120px] opacity-20 -translate-y-1/2 translate-x-1/2"></div>

              {!subscribed ? (
                <>
                  <h2 className="text-3xl font-black mb-4">
                    JOIN THE COLLECTIVE
                  </h2>
                  <p className="text-gray-400 max-w-lg mx-auto mb-8 font-medium">
                    Receive exclusive access to new drops, artisan stories, and
                    a 10% discount on your first luxury order.
                  </p>
                  <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-2">
                    <input
                      type="email"
                      placeholder="Enter your email"
                      className="bg-white/10 border border-white/20 rounded-xl px-6 py-4 flex-1 outline-none focus:ring-2 focus:ring-pink-500"
                      value={subscriberEmail}
                      onChange={(e) => setSubscriberEmail(e.target.value)}
                    />
                    <button
                      onClick={handleSubscribe}
                      className="bg-pink-500 text-white font-black px-8 py-4 rounded-xl hover:bg-pink-600 transition-colors shadow-xl"
                    >
                      SUBSCRIBE
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center">
                  <h2 className="text-3xl font-black mb-4">
                    Thank you for subscribing!
                  </h2>
                  <p className="text-gray-400 max-w-lg mx-auto font-medium">
                    Updates will be sent to{" "}
                    <span className="font-bold">{subscriberEmail}</span>.
                  </p>
                </div>
              )}
            </section>
          </div>
        )}
        {/* CHECKOUT PAGE */}
        {activePage === "checkout" && (
          <div className="max-w-4xl mx-auto py-10">
            <div className="flex items-center gap-4 mb-10">
              <button
                onClick={() => navigate("home")}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <ChevronLeft />
              </button>
              <h1 className="text-3xl font-black">CHECKOUT</h1>
              <div className="ml-auto flex gap-2">
                {[1, 2, 3].map((s) => (
                  <div
                    key={s}
                    className={`w-3 h-3 rounded-full ${
                      checkoutStep >= s ? "bg-pink-500" : "bg-gray-200"
                    }`}
                  />
                ))}
              </div>
            </div>

            <div className="grid md:grid-cols-[1fr_350px] gap-10">
              <div className="space-y-8">
                {/* Step 1: Address */}
                {/* Address Selection + Edit */}
                <div className="p-6 rounded-2xl border-2 transition-all checkoutStep === 1 ? 'border-pink-500 bg-pink-50' : 'border-gray-100 opacity-60'">
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="font-black flex items-center gap-2">
                      <MapPin size={20} /> SHIPPING ADDRESS
                    </h3>
                    <button
                      onClick={() => setIsEditingAddress(!isEditingAddress)}
                      className="text-xs font-bold text-pink-600 uppercase flex items-center gap-1"
                    >
                      {isEditingAddress ? "Cancel" : "Edit"}
                      <ChevronDown size={14} />
                    </button>
                  </div>

                  {isEditingAddress ? (
                    /* Edit Form */
                    <div className="space-y-4">
                      <input
                        className="w-full p-4 bg-white border rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                        placeholder="Full Name"
                        value={address.name}
                        onChange={(e) =>
                          setAddress({ ...address, name: e.target.value })
                        }
                      />
                      <input
                        className="w-full p-4 bg-white border rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                        placeholder="Street Address"
                        value={address.street}
                        onChange={(e) =>
                          setAddress({ ...address, street: e.target.value })
                        }
                      />
                      <div className="grid grid-cols-2 gap-4">
                        <input
                          className="p-4 bg-white border rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                          placeholder="City"
                          value={address.city}
                          onChange={(e) =>
                            setAddress({ ...address, city: e.target.value })
                          }
                        />
                        <input
                          className="p-4 bg-white border rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                          placeholder="Zip Code"
                          value={address.zip}
                          onChange={(e) =>
                            setAddress({ ...address, zip: e.target.value })
                          }
                        />
                      </div>
                      <div className="flex gap-3 pt-4">
                        <button
                          onClick={() => {
                            setIsEditingAddress(false);
                            setUser((prev) => ({ ...prev, address })); // Save to user profile
                          }}
                          className="flex-1 bg-slate-900 text-white py-3 px-6 rounded-xl font-bold hover:bg-pink-500"
                        >
                          Save Address
                        </button>
                        <button
                          onClick={() => setIsEditingAddress(false)}
                          className="flex-1 bg-gray-100 text-gray-700 py-3 px-6 rounded-xl font-bold"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    /* Display Saved Address */
                    <div>
                      <p className="font-bold text-lg mb-2">{address.name}</p>
                      <p className="text-gray-600 mb-1">{address.street}</p>
                      <p className="text-gray-600">
                        {address.city}, {address.zip}
                      </p>
                      <button
                        onClick={() => setCheckoutStep(2)}
                        className="mt-6 w-full bg-slate-900 text-white py-4 rounded-xl font-bold shadow-lg hover:bg-pink-600"
                      >
                        Use This Address
                      </button>
                    </div>
                  )}
                </div>

                {/* Step 2: Payment Selection */}
                <div
                  className={`p-6 rounded-2xl border-2 transition-all ${
                    checkoutStep === 2
                      ? "border-pink-500 bg-white"
                      : "border-gray-100 opacity-60"
                  }`}
                >
                  <h3 className="font-black flex items-center gap-2 mb-6">
                    <CardIcon size={20} /> PAYMENT METHOD
                  </h3>
                  {checkoutStep >= 2 && (
                    <div className="space-y-3">
                      {[
                        {
                          id: "card",
                          name: "Credit / Debit Card",
                          icon: <CardIcon size={20} />,
                        },
                        {
                          id: "amazon",
                          name: "Amazon Pay",
                          icon: <ShoppingBag size={20} />,
                        },
                        {
                          id: "phonepe",
                          name: "PhonePe / UPI",
                          icon: <Smartphone size={20} />,
                        },
                        {
                          id: "gpay",
                          name: "Google Pay",
                          icon: <Smartphone size={20} />,
                        },
                        {
                          id: "paytm",
                          name: "Paytm Wallet",
                          icon: <Smartphone size={20} />,
                        },
                        {
                          id: "cod",
                          name: "Cash On Delivery",
                          icon: <Clock size={20} />,
                        },
                      ].map((pay) => (
                        <label
                          key={pay.id}
                          className={`flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all ${
                            selectedPayment === pay.id
                              ? "border-pink-500 bg-pink-50"
                              : "border-gray-50 bg-gray-50 hover:border-gray-200"
                          }`}
                        >
                          <input
                            type="radio"
                            checked={selectedPayment === pay.id}
                            onChange={() => setSelectedPayment(pay.id)}
                            className="w-4 h-4 text-pink-500 accent-pink-500"
                          />
                          <div className="text-gray-400">{pay.icon}</div>
                          <span className="font-bold text-sm">{pay.name}</span>
                        </label>
                      ))}
                      {checkoutStep === 2 && (
                        <button
                          disabled={!selectedPayment}
                          onClick={() =>
                            selectedPayment === "card"
                              ? setCheckoutStep(3)
                              : placeOrder()
                          }
                          className="w-full mt-6 bg-slate-900 text-white py-4 rounded-xl font-bold shadow-lg disabled:opacity-50"
                        >
                          {selectedPayment === "card"
                            ? "Enter Card Details"
                            : "Complete Order"}
                        </button>
                      )}
                    </div>
                  )}
                </div>

                {/* Step 3: Card Details */}
                {checkoutStep === 3 && (
                  <div className="p-6 rounded-2xl border-2 border-pink-500 bg-white animate-slide">
                    <h3 className="font-black flex items-center gap-2 mb-6">
                      <CardIcon size={20} /> CARD DETAILS
                    </h3>
                    <div className="space-y-4">
                      <input
                        className="w-full p-4 bg-gray-50 rounded-xl outline-none"
                        placeholder="Card Number"
                      />
                      <div className="grid grid-cols-2 gap-4">
                        <input
                          className="p-4 bg-gray-50 rounded-xl outline-none"
                          placeholder="MM/YY"
                        />
                        <input
                          className="p-4 bg-gray-50 rounded-xl outline-none"
                          placeholder="CVV"
                        />
                      </div>
                      <button
                        onClick={placeOrder}
                        className="w-full py-4 bg-slate-900 text-white rounded-xl font-bold shadow-lg"
                      >
                        Pay & Confirm
                      </button>
                    </div>
                  </div>
                )}

                {/* Step 4: Success */}
                {checkoutStep === 4 && (
                  <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 shadow-2xl animate-in zoom-in duration-500">
                    <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                      <CheckCircle size={48} />
                    </div>
                    <h2 className="text-3xl font-black mb-2">ORDER PLACED!</h2>
                    <p className="text-gray-500 mb-8 max-w-xs mx-auto">
                      We've sent a confirmation email to <b>{user.email}</b>.
                      Your unique piece is being prepared.
                    </p>
                    <div className="flex flex-col gap-3 max-w-xs mx-auto">
                      <button
                        onClick={() => navigate("home")}
                        className="w-full py-4 bg-slate-900 text-white rounded-xl font-bold"
                      >
                        Continue Shopping
                      </button>
                      <button
                        onClick={() => navigate("orders")}
                        className="w-full py-4 bg-gray-100 text-gray-700 rounded-xl font-bold"
                      >
                        Track Order
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Summary Column */}
              {checkoutStep < 4 && (
                <aside className="space-y-6">
                  <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm sticky top-28">
                    <h4 className="font-black mb-4">ORDER SUMMARY</h4>
                    <div className="space-y-3 mb-6">
                      <div className="flex justify-between text-sm text-gray-500">
                        <span>Subtotal</span>
                        <span>{INR.format(subtotal)}</span>
                      </div>
                      <div className="flex justify-between text-sm text-gray-500">
                        <span>Shipping</span>
                        <span className="text-green-600 font-bold">FREE</span>
                      </div>
                      <div className="flex justify-between text-sm text-gray-500">
                        <span>Tax</span>
                        <span>$0.00</span>
                      </div>
                      <div className="pt-3 border-t flex justify-between font-black text-xl">
                        <span>Total</span>
                        <span>{INR.format(subtotal)}</span>
                      </div>
                    </div>
                    <div className="space-y-3">
                      {cart.map((i) => (
                        <div
                          key={i.id}
                          className="flex gap-2 text-[10px] font-bold text-gray-400"
                        >
                          <span className="text-slate-900">{i.qty}x</span>{" "}
                          {i.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </aside>
              )}
            </div>
          </div>
        )}
        {/* LOGIN PAGE */}
        {/* {activePage === "login" && (
          <div className="max-w-md mx-auto py-20">
            <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-xl text-center">
              <h1 className="text-3xl font-black mb-2 uppercase">
                Welcome Back
              </h1>
              <p className="text-gray-400 text-sm mb-10">
                Sign in to your luxury account
              </p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setUser({
                    name: e.target.email.value.split("@")[0],
                    email: e.target.email.value,
                    bio: "Luxury Lover",
                    phone: "+39 123 456 789",
                  });
                  navigate("home");
                }}
                className="space-y-4"
              >
                <input
                  name="email"
                  type="email"
                  required
                  placeholder="Email Address"
                  className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                />
                <input
                  type="password"
                  required
                  placeholder="Password"
                  className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                />
                <button
                  type="submit"
                  className="w-full py-4 bg-slate-900 text-white rounded-xl font-black text-lg shadow-xl shadow-slate-200 hover:bg-pink-600 transition-all"
                >
                  SIGN IN
                </button>
              </form>
              <p className="mt-8 text-xs text-gray-400 font-medium leading-relaxed">
                By signing in, you agree to our{" "}
                <span className="text-pink-500 cursor-pointer">Terms</span> and{" "}
                <span className="text-pink-500 cursor-pointer">
                  Privacy Policy
                </span>
                .
              </p>
            </div>
          </div>
        )} */}
        {activePage === "login" && (
          <div className="max-w-md mx-auto py-20">
            <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-xl text-center">
              <h1 className="text-3xl font-black mb-2 uppercase">
                Welcome Back
              </h1>
              <p className="text-gray-400 text-sm mb-10">
                Sign in to your luxury account
              </p>
              {/* <form
                onSubmit={async (e) => {
                  e.preventDefault();

                  const formData = {
                    name: e.target.name.value,
                    email: e.target.email.value,
                    phone: e.target.phone.value,
                    password: e.target.password.value,
                  };

                  try {
                    const res = await fetch("http://localhost:3000/api/login", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(formData),
                    });

                    const data = await res.json();

                    if (!res.ok) {
                      alert(data.message);
                      return;
                    }

                    // SUCCESS
                    setUser(data.user);
                    navigate("home");
                  } catch (error) {
                    console.error(error);
                    alert("Server error");
                  }
                }}
                className="space-y-4"
              > */}
              {/* Step 1: Enter details */}
              {step === 1 && (
                <div className="space-y-4">
                  <input
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                  />
                  <input
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                  />
                  <input
                    placeholder="Mobile Number"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                    className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                  />
                  <button
                    onClick={handleSendOtp}
                    className="w-full py-4 bg-slate-900 text-white rounded-xl font-black hover:bg-pink-600 transition-all"
                  >
                    Send OTP
                  </button>
                </div>
              )}

              {/* Step 2: Enter OTP */}
              {step === 2 && (
                <div className="space-y-4">
                  <input
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="w-full p-4 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-pink-500"
                  />
                  <button
                    onClick={handleVerifyOtp}
                    className="w-full py-4 bg-slate-900 text-white rounded-xl font-black hover:bg-pink-600 transition-all"
                  >
                    Verify OTP
                  </button>
                </div>
              )}

              {/* Step 3: Login Success */}
              {step === 3 && user && (
                <div>
                  <h2 className="text-2xl font-bold">Welcome, {user.name}!</h2>
                  <p className="text-gray-500">{user.email}</p>
                  <p className="text-gray-500">{user.phone}</p>
                </div>
              )}
              {/* </form> */}
              <p className="mt-8 text-xs text-gray-400 font-medium leading-relaxed">
                By signing in, you agree to our{" "}
                <span className="text-pink-500 cursor-pointer">Terms</span> and{" "}
                <span className="text-pink-500 cursor-pointer">
                  Privacy Policy
                </span>
                .
              </p>
            </div>
          </div>
        )}

        {/* PROFILE PAGE */}
        {/* {activePage === "profile" && user && ( */}
        {/* // <div className="max-w-4xl mx-auto py-10">
          //   <h1 className="text-4xl font-black mb-10">MY PROFILE</h1>
          //   <div className="bg-white rounded-3xl border border-gray-100 shadow-xl overflow-hidden">
          //     <div className="bg-slate-900 h-32 relative">
          //       <div className="absolute -bottom-12 left-10 w-24 h-24 bg-orange-100 rounded-full border-4 border-white flex items-center justify-center text-4xl font-black text-orange-600 shadow-lg">
          //         {user.name[0]}
          //       </div>
          //     </div>
          //     <div className="pt-16 px-10 pb-10">
          //       <div className="flex justify-between items-start mb-10">
          //         <div>
          //           <h2 className="text-2xl font-black">{user.name}</h2>
          //           <p className="text-gray-500 font-medium">{user.email}</p>
          //         </div>
          //         <button */}
        {/* //           onClick={() => showNotification("Profile edits saved")}
          //           className="px-6 py-2 border-2 border-slate-900 rounded-full font-black text-xs hover:bg-slate-900 hover:text-white transition-all"
          //         >
          //           EDIT PROFILE
          //         </button>
          //       </div> */}

        {/* //       <div className="grid md:grid-cols-2 gap-10">
          //         <div className="space-y-6">
          //           <div>
          //             <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          //               Bio
          //             </label>
          //             <p className="font-bold text-gray-700 mt-1 italic">
          //               "{user.bio}"
          //             </p>
          //           </div>
          //           <div>
          //             <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          //               Phone
          //             </label>
          //             <p className="font-bold text-gray-700 mt-1">
          //               {user.phone}
          //             </p>
          //           </div>
          //         </div>
          //         <div className="space-y-6">
          //           <div>
          //             <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          //               Default Address
          //             </label>
          //             <p className="font-bold text-gray-700 mt-1">
          //               {address.street}, {address.city}
          //             </p>
          //           </div>
          //           <div>
          //             <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          //               Member Since
          //             </label>
          //             <p className="font-bold text-gray-700 mt-1">
          //               December 2025
          //             </p>
          //           </div>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div> */}
        {activePage === "profile" &&
          (!user ? (
            <div className="text-center py-20">
              <p className="font-bold text-gray-500">
                Please sign in to view your profile
              </p>
              <button
                onClick={() => navigate("login")}
                className="mt-4 bg-slate-900 text-white px-6 py-3 rounded-xl font-bold"
              >
                Sign In
              </button>
            </div>
          ) : (
            editData && (
              <div className="max-w-4xl mx-auto py-10">
                <h1 className="text-4xl font-black mb-10">MY PROFILE</h1>
                <div className="bg-white rounded-3xl border border-gray-100 shadow-xl overflow-hidden">
                  <div className="bg-slate-900 h-32 relative">
                    <div className="absolute -bottom-12 left-10 w-24 h-24 bg-pink-100 rounded-full border-4 border-white flex items-center justify-center text-4xl font-black text-pink-600 shadow-lg">
                      {user.name[0]}
                    </div>
                  </div>
                  <div className="pt-16 px-10 pb-10">
                    <div className="flex justify-between items-start mb-10">
                      <div>
                        {editing ? (
                          <input
                            type="text"
                            value={editData.name}
                            onChange={(e) =>
                              setEditData({ ...editData, name: e.target.value })
                            }
                            className="text-2xl font-black border-b border-gray-500 focus:outline-none"
                          />
                        ) : (
                          <h2 className="text-2xl font-black">{user.name}</h2>
                        )}
                        <p className="text-gray-500 font-medium">
                          {user.email}
                        </p>
                      </div>
                      {editing ? (
                        <div className="flex gap-4">
                          <button
                            onClick={saveProfile}
                            className="px-6 py-2 border-2 border-green-600 rounded-full font-black text-xs text-green-600 hover:bg-green-600 hover:text-white transition-all"
                          >
                            SAVE
                          </button>
                          <button
                            onClick={() => setEditing(false)}
                            className="px-6 py-2 border-2 border-red-600 rounded-full font-black text-xs text-red-600 hover:bg-red-600 hover:text-white transition-all"
                          >
                            CANCEL
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => setEditing(true)}
                          className="px-6 py-2 border-2 border-slate-900 rounded-full font-black text-xs hover:bg-slate-900 hover:text-white transition-all"
                        >
                          EDIT PROFILE
                        </button>
                      )}
                    </div>

                    <div className="grid md:grid-cols-2 gap-10">
                      <div className="space-y-6">
                        <div>
                          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                            Bio
                          </label>
                          {editing ? (
                            <textarea
                              value={editData.bio}
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  bio: e.target.value,
                                })
                              }
                              className="w-full border border-gray-300 rounded p-2"
                              rows={3}
                            />
                          ) : (
                            <p className="font-bold text-gray-700 mt-1 italic">
                              "{user.bio}"
                            </p>
                          )}
                        </div>
                        <div>
                          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                            Phone
                          </label>
                          {editing ? (
                            <input
                              type="text"
                              value={editData.phone}
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  phone: e.target.value,
                                })
                              }
                              className="w-full border border-gray-300 rounded p-2"
                            />
                          ) : (
                            <p className="font-bold text-gray-700 mt-1">
                              {user.phone}
                            </p>
                          )}
                        </div>
                        {/* Bank details section (optional) */}
                        <div>
                          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                            Bank Details (Optional)
                          </label>
                          {editing ? (
                            <>
                              <input
                                type="text"
                                placeholder="Account Number"
                                value={editData.accountNumber}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    accountNumber: e.target.value,
                                  })
                                }
                                className="w-full border border-gray-300 rounded p-2 mb-2"
                              />
                              <input
                                type="text"
                                placeholder="IFSC Code"
                                value={editData.ifsc}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    ifsc: e.target.value,
                                  })
                                }
                                className="w-full border border-gray-300 rounded p-2"
                              />
                            </>
                          ) : (
                            <>
                              {user.bankDetails.accountNumber ||
                              user.bankDetails.ifsc ? (
                                <p className="font-bold text-gray-700 mt-1">
                                  Account:{" "}
                                  {user.bankDetails.accountNumber || "-"} <br />
                                  IFSC: {user.bankDetails.ifsc || "-"}
                                </p>
                              ) : (
                                <p className="font-bold text-gray-700 mt-1 italic text-gray-400">
                                  No bank details provided
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="space-y-6">
                        <div>
                          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                            Default Address
                          </label>
                          {editing ? (
                            <>
                              <input
                                type="text"
                                value={editData.street}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    street: e.target.value,
                                  })
                                }
                                placeholder="Street"
                                className="w-full border border-gray-300 rounded p-2 mb-2"
                              />
                              <input
                                type="text"
                                value={editData.city}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    city: e.target.value,
                                  })
                                }
                                placeholder="City"
                                className="w-full border border-gray-300 rounded p-2"
                              />
                            </>
                          ) : (
                            <p className="font-bold text-gray-700 mt-1">
                              {user.address.street}, {user.address.city}
                            </p>
                          )}
                        </div>
                        <div>
                          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                            Member Since
                          </label>
                          <p className="font-bold text-gray-700 mt-1">
                            December 2025
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          ))}
        {/* WISHLIST PAGE */}
        {activePage === "wishlist" && (
          <div className="max-w-6xl mx-auto py-10">
            <h1 className="text-4xl font-black mb-10">
              WISHLIST ({wishlist.length})
            </h1>
            {wishlist.length === 0 ? (
              <div className="bg-white p-20 text-center rounded-3xl border border-gray-100">
                <Heart className="mx-auto text-gray-100 mb-6" size={80} />
                <p className="font-bold text-gray-400 mb-6">
                  Your heart is empty. Fill it with luxury.
                </p>
                <button
                  onClick={() => navigate("home")}
                  className="bg-slate-900 text-white px-10 py-4 rounded-xl font-black"
                >
                  Explore Collections
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {wishlist.map((p) => (
                  <ProductCard
                    key={p.id}
                    p={p}
                    onProductClick={() => setSelectedProduct(p)}
                  />
                  // <img
                  //   src={p.image}
                  //   alt={p.name}
                  //   className="w-16 h-16 object-cover rounded"
                  // />
                ))}
              </div>
            )}
          </div>
        )}
        {/* ORDER HISTORY PAGE */}
        {activePage === "orders" && (
          <div className="max-w-4xl mx-auto py-10">
            <h1 className="text-4xl font-black mb-10">ORDER HISTORY</h1>
            {orders.length === 0 ? (
              <div className="bg-white p-20 text-center rounded-3xl border border-gray-100">
                <Package className="mx-auto text-gray-100 mb-6" size={80} />
                <p className="font-bold text-gray-400 mb-6">No orders found.</p>
                <button
                  onClick={() => navigate("home")}
                  className="bg-slate-900 text-white px-10 py-4 rounded-xl font-black"
                >
                  Back to Shop
                </button>
              </div>
            ) : (
              <div className="space-y-6">
                {orders.map((order) => (
                  <div
                    key={order.id}
                    className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => setSelectedOrder(order)}
                  >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center text-blue-500 font-black text-xs tracking-tighter">
                          {order.items.length} ITEM
                        </div>
                        <div>
                          <p className="font-black">{order.id}</p>
                          <p className="text-xs text-gray-400 font-bold uppercase">
                            {order.date}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-10">
                        <div className="text-right">
                          <p className="text-xs text-gray-400 font-bold uppercase">
                            Total
                          </p>
                          <p className="font-black text-lg">
                            {INR.format(order.total)}
                          </p>
                        </div>
                        <div
                          className={`px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest ${
                            order.status === "Processing"
                              ? "bg-pink-100 text-pink-600"
                              : "bg-green-100 text-green-600"
                          }`}
                        >
                          {order.status}
                        </div>
                        <ChevronRight className="text-gray-300" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Order Details Modal */}
            {selectedOrder && (
              <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
                <div
                  className="absolute inset-0 bg-slate-900/60 backdrop-blur"
                  onClick={() => setSelectedOrder(null)}
                />
                <div className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl relative overflow-hidden animate-in zoom-in">
                  <div className="p-8 border-b bg-gray-50 flex justify-between items-center">
                    <div>
                      <p className="text-xs text-gray-400 font-black uppercase">
                        Order Details
                      </p>
                      <h3 className="text-2xl font-black">
                        {selectedOrder.id}
                      </h3>
                    </div>
                    <X
                      className="cursor-pointer"
                      onClick={() => setSelectedOrder(null)}
                    />
                  </div>
                  <div className="p-8 space-y-8 overflow-y-auto max-h-[70vh] no-scrollbar">
                    {/* Live Tracking Simulator */}
                    <div className="p-6 bg-slate-900 rounded-2xl text-white">
                      <div className="flex justify-between items-center mb-6">
                        <h4 className="font-black flex items-center gap-2">
                          <Clock size={16} /> LIVE TRACKING
                        </h4>
                        <span className="text-[10px] font-black text-pink-500 uppercase">
                          Estimated: Tomorrow
                        </span>
                      </div>
                      <div className="flex gap-1">
                        <div className="h-1 flex-1 bg-pink-500 rounded-full"></div>
                        <div className="h-1 flex-1 bg-pink-500 rounded-full"></div>
                        <div className="h-1 flex-1 bg-white/20 rounded-full"></div>
                        <div className="h-1 flex-1 bg-white/20 rounded-full"></div>
                      </div>
                      <p className="text-[10px] font-bold text-gray-400 mt-2 uppercase tracking-widest">
                        In Artisan Quality Control
                      </p>
                    </div>

                    <div className="grid grid-cols-2 gap-8">
                      <div>
                        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
                          Shipping To
                        </p>
                        <p className="text-sm font-bold">
                          {selectedOrder.address.name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {selectedOrder.address.street},{" "}
                          {selectedOrder.address.city}
                        </p>
                      </div>
                      <div>
                        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
                          Payment
                        </p>
                        <p className="text-sm font-bold uppercase">
                          {selectedOrder.payment}
                        </p>
                        <p className="text-xs text-green-600 font-bold">
                          Transaction Confirmed
                        </p>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                        Ordered Items
                      </p>
                      {selectedOrder.items.map((item) => (
                        <div
                          key={item.id}
                          className="flex justify-between items-center py-2 border-b border-gray-50"
                        >
                          <div className="flex items-center gap-3">
                            {/* <div
                              className="w-10 h-10 rounded bg-gray-100"
                              style={{ backgroundColor: `${item.color}20` }}
                            ></div> */}
                            <img
                              src={item.image}
                              alt={item.name}
                              className="w-10 h-10 rounded object-cover"
                            />

                            <span className="text-sm font-bold">
                              {item.name}{" "}
                              <span className="text-gray-400 ml-1 font-normal">
                                x{item.qty}
                              </span>
                            </span>
                          </div>
                          <span className="font-black text-sm">
                            {INR.format(item.price * item.qty)}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="pt-4 flex justify-between items-end">
                      <button
                        onClick={() => showNotification("Support request sent")}
                        className="text-xs font-black text-pink-600 uppercase border-b-2 border-pink-500 pb-1"
                      >
                        Need help with this order?
                      </button>
                      <div className="text-right">
                        <p className="text-xs text-gray-400 font-black uppercase tracking-widest">
                          Final Total
                        </p>
                        <p className="text-3xl font-black">
                          {INR.format(selectedOrder.total)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/* product details model */}
        {selectedProduct && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-slate-900/60 backdrop-blur"
              onClick={() => setSelectedProduct(null)}
            />
            <div className="bg-white w-full max-w-4xl rounded-3xl shadow-2xl relative overflow-hidden max-h-[90vh] flex flex-col overflow-y-auto animate-in zoom-in">
              {/* Header */}
              <div className="p-8 border-b bg-gray-50 flex justify-between items-center">
                <div>
                  <h3 className="text-2xl font-black">
                    {selectedProduct.name}
                  </h3>
                  <p className="text-sm text-pink-600 font-bold">
                    In Stock ({selectedProduct.stock})
                  </p>
                </div>
                <X
                  className="cursor-pointer"
                  onClick={() => setSelectedProduct(null)}
                  size={24}
                />
              </div>

              {/* Main Content */}
              <div className="p-8 grid md:grid-cols-2 gap-12">
                <div>
                  {/* <div
                    className="relative aspect-square rounded-2xl overflow-hidden bg-gray-50 mb-6"
                    style={{ backgroundColor: `${selectedProduct.color}20` }}
                  >
                    <ShoppingBag
                      size={120}
                      style={{ color: selectedProduct.color }}
                      className="absolute inset-0 m-auto opacity-20"
                    />
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-900/10" />
                  </div> */}
                  <div className="relative aspect-square rounded-2xl overflow-hidden bg-gray-50 mb-6">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="flex items-center gap-2 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="text-pink-400 fill-current"
                        size={16}
                      />
                    ))}
                    <span className="text-sm font-bold text-gray-500">
                      {selectedProduct.rating}
                    </span>
                  </div>
                  <div className="flex gap-3 mb-6">
                    <button
                      onClick={() => addToCart(selectedProduct)}
                      className="flex-1 bg-slate-900 text-white py-3 px-6 rounded-xl font-bold hover:bg-pink-500 transition-all"
                    >
                      Add to Basket
                    </button>
                    <button
                      onClick={() => toggleWishlist(selectedProduct)}
                      className="p-3 bg-white border-2 border-gray-200 rounded-xl hover:bg-pink-50 transition-all"
                    >
                      {/* <Heart
                        size={20}
                        className={`wishlist.find(i => i.id === selectedProduct.id) ? "text-red-500 fill-current" : "text-gray-400"`}
                      /> */}
                      <Heart
                        size={20}
                        className={
                          wishlist.find((i) => i.id === selectedProduct.id)
                            ? "text-red-500 fill-current"
                            : "text-gray-400"
                        }
                      />
                    </button>
                  </div>
                </div>

                {/* Product Details */}
                <div>
                  <h4 className="text-lg font-black mb-4 uppercase tracking-wider">
                    Product Details
                  </h4>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {selectedProduct.desc}
                  </p>

                  <h5 className="font-bold text-sm uppercase tracking-wider mb-3 flex items-center gap-2">
                    <Info size={16} /> Usage Instructions
                  </h5>
                  <ul className="text-sm text-gray-600 space-y-2 mb-8">
                    <li>• Hand wash only in cold water</li>
                    <li>• Air dry away from direct sunlight</li>
                    <li>• Store flat to maintain shape</li>
                    <li>• Spot clean stains with mild soap</li>
                  </ul>

                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-gray-400 uppercase tracking-wider text-xs">
                        Category
                      </span>
                      <p className="font-bold">{selectedProduct.category}</p>
                    </div>
                    <div>
                      <span className="text-gray-400 uppercase tracking-wider text-xs">
                        Price
                      </span>
                      <p className="text-2xl font-black text-gray-900">
                        ₹{selectedProduct.price}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Similar Products - Amazon Style */}
              {similarProducts.length > 0 && (
                <div className="border-t p-8">
                  <h4 className="text-xl font-black mb-6 uppercase tracking-wider flex items-center gap-2">
                    Similar Items{" "}
                    <span className="text-pink-500">
                      ({similarProducts.length})
                    </span>
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {similarProducts.map((p) => (
                      <div
                        key={p.id}
                        className="group cursor-pointer"
                        onClick={() => setSelectedProduct(p)}
                      >
                        {/* <div
                          className="aspect-square rounded-xl overflow-hidden bg-gray-50 group-hover:scale-105 transition-transform"
                          style={{ backgroundColor: `${p.color}20` }}
                        >
                          <ShoppingBag
                            size={40}
                            style={{ color: p.color }}
                            className="opacity-40 absolute inset-0 m-auto"
                          />
                        </div> */}
                        <div className="aspect-square rounded-xl overflow-hidden bg-gray-50 group-hover:scale-105 transition-transform">
                          <img
                            src={p.image}
                            alt={p.name}
                            className="w-full h-full object-cover"
                          />
                        </div>

                        <p className="font-bold text-sm mt-2 line-clamp-2">
                          {p.name}
                        </p>
                        <p className="text-pink-600 font-black text-xs">
                          ₹{p.price}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {/* CUSTOMER SERVICE PAGE */}
        {activePage === "help" && (
          <div className="max-w-4xl mx-auto py-10">
            <h1 className="text-4xl font-black mb-10">CUSTOMER SERVICE</h1>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <a
                href="tel:91+6281454296"
                className="block bg-white p-8 rounded-3xl border border-gray-100 text-center space-y-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center mx-auto">
                  <Phone size={24} />
                </div>
                <h3 className="font-black">Call Concierge</h3>
                <p className="text-xs text-gray-500">
                  24/7 dedicated support for client.
                </p>
                <p className="font-black text-sm text-slate-900">
                  +91-6281454296
                </p>
              </a>
              <a
                href="mailto:ravali1232@gmail.com it?subject=Customer Support Request"
                className="block bg-white p-8 rounded-3xl border border-gray-100 text-center space-y-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto">
                  <Mail size={24} />
                </div>
                <h3 className="font-black">Email Artisan</h3>
                <p className="text-xs text-gray-500">
                  Direct channel to our head weavers.
                </p>
                <p className="font-black text-sm text-slate-900">
                  <a href="mailto:ravalilone123@gmail.com">send Email</a>
                </p>
              </a>
              <div className="bg-white p-8 rounded-3xl border border-gray-100 text-center space-y-4 shadow-sm">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto">
                  <MessageCircle size={24} />
                </div>
                <h3 className="font-black">Live Chat</h3>
                <p className="text-xs text-gray-500">
                  Instant response from our office.
                </p>
                {/* <button className="bg-slate-900 text-white px-6 py-2 rounded-full font-bold text-xs uppercase">
                  Start Chat
                </button> */}
                {/* <button
                  onClick={() => navigate("chat")}
                  className="bg-slate-900 text-white px-6 py-2 rounded-full font-bold text-xs uppercase hover:bg-orange-500 transition-colors"
                >
                  Start Chat
                </button> */}
                <a
                  href="https://wa.me/6281454296"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-slate-900 text-white px-6 py-2 rounded-full font-bold text-xs uppercase"
                >
                  Start Chat
                </a>
              </div>
            </div>

            <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
              <h2 className="text-2xl font-black mb-8">FREQUENT QUESTIONS</h2>
              <div className="space-y-6">
                {[
                  {
                    q: "How long does a custom order take?",
                    a: "Each piece is hand-knotted. Standard items ship in 4-5 days, custom creations may take up to 14 days.",
                  },
                  {
                    q: "Do you offer international shipping?",
                    a: "No, At present we ship only in India.",
                  },
                  {
                    q: "What is your return policy for luxury items?",
                    a: "We offer a 30-day crafted guarantee. If the stitch work isn't perfect, we'll replace or refund.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="pb-6 border-b border-gray-50 last:border-0"
                  >
                    <p className="font-black text-slate-900 mb-2">{item.q}</p>
                    <p className="text-sm text-gray-500 leading-relaxed font-medium">
                      {item.a}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* SHIPPING POLICIES PAGE */}
        {activePage === "shipping" && (
          <div className="max-w-3xl mx-auto py-10 space-y-12">
            <h1 className="text-4xl font-black">SHIPPING POLICIES</h1>
            <div className="prose prose-slate max-w-none space-y-8">
              <section className="space-y-4">
                <h2 className="text-2xl font-black flex items-center gap-3">
                  <Truck className="text-pink-500" /> Country Artisan Network
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  CrochetBeee Luxury operates a direct-to-consumer model from
                  our artisans across India. This ensures your piece hasn't sat
                  in a warehouse for months.
                </p>
              </section>
              <section className="space-y-4">
                <h3 className="font-black text-xl">Standard Shipping Times</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 bg-gray-50 rounded-xl">
                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                      Telangana
                    </p>
                    <p className="font-bold">
                      4 - 6 Business Days and may vary
                    </p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-xl">
                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                      India
                    </p>
                    <p className="font-bold">
                      8 - 12 Business Days and may vary
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}
        {/* PRIVACY POLICY PAGE */}
        {activePage === "privacy" && (
          <div className="max-w-3xl mx-auto py-10 space-y-12">
            <h1 className="text-4xl font-black">PRIVACY & SECURITY</h1>
            <div className="prose prose-slate max-w-none space-y-8">
              <section className="space-y-4">
                <h2 className="text-2xl font-black flex items-center gap-3">
                  <ShieldCheck className="text-blue-500" /> Data Encryption
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  We use AES-256-bit encryption for all personal data. Your
                  payment information is processed through Stripe/PCI-compliant
                  servers and is never stored on our database.
                </p>
              </section>
              <section className="space-y-4">
                <h3 className="font-black text-xl">Information Usage</h3>
                <p className="text-gray-600 leading-relaxed">
                  We only collect data necessary to fulfill your luxury artisan
                  order and improve your browsing experience. We never sell your
                  data to third-party marketing firms.
                </p>
              </section>
            </div>
          </div>
        )}
        {/*heritage page*/}
        {activePage === "heritage" && (
          <div className="max-w-5xl mx-auto py-20">
            <h1 className="text-4xl font-black mb-6">Our Heritage</h1>
            <p className="text-gray-600 mb-6 leading-relaxed">
              CrochetBeee Luxury Artisan is rooted in centuries of weaving
              tradition. Each creation is a tribute to master artisans, their
              craftsmanship, and the heritage of weaving culture.
            </p>
            <section className="grid md:grid-cols-2 gap-12 items-center mb-12">
              <div>
                <img
                  src={backg3}
                  alt="heritage"
                  className="w-full h-full object-cover rounded-3xl shadow-2xl"
                />
              </div>
              <div className="space-y-6">
                <h2 className="text-2xl font-black">Craftsmanship & Legacy</h2>
                <p className="text-gray-600 leading-relaxed">
                  Each piece is hand-knotted with a single continuous thread,
                  symbolizing the connection between artisan and wearer. Our
                  mission is to preserve traditional weaving while creating
                  modern luxury pieces.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  From sustainably sourced materials to artisan direct shipping,
                  every step reflects our commitment to quality and heritage.
                </p>
              </div>
            </section>
            <button
              onClick={() => setActivePage("home")}
              className="text-sm text-pink-600 font-bold underline"
            >
              ← Back to Home
            </button>
          </div>
        )}

        {/* Terms of Service Page */}
        {activePage === "terms" && (
          <div className="max-w-3xl mx-auto py-10 space-y-12">
            <h1 className="text-4xl font-black">TERMS OF SERVICE</h1>
            <div className="prose prose-slate max-w-none space-y-8">
              <section className="space-y-4">
                <h2 className="text-2xl font-black flex items-center gap-3 ShieldCheck className='text-green-500'">
                  Acceptance of Terms
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  By accessing CrochetBeee Luxury, you agree to these terms. We
                  reserve the right to update them with notice.
                </p>
              </section>
              <section className="space-y-4">
                <h2 className="text-2xl font-black">Order & Payment</h2>
                <p className="text-gray-600 leading-relaxed">
                  All sales are final for custom artisan pieces. Payments
                  processed securely via PCI-compliant gateways.
                </p>
              </section>
              <section className="space-y-4">
                <h3 className="font-black text-xl">Governing Law</h3>
                <p className="text-gray-600 leading-relaxed">
                  These terms governed by Indian law. Disputes resolved in
                  Hyderabad courts.
                </p>
              </section>
            </div>
            <button
              onClick={() => setActivePage("home")}
              className="text-pink-600 font-black underline"
            >
              Back to Home
            </button>
          </div>
        )}

        {/* Sustainability Page */}
        {activePage === "sustainability" && (
          <div className="max-w-4xl mx-auto py-10 space-y-12">
            <h1 className="text-4xl font-black">SUSTAINABILITY</h1>
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-black mb-6">Our Eco Commitment</h2>
                <ul className="text-sm text-gray-600 space-y-3">
                  <li>• 100% GOTS-certified organic cotton & natural dyes</li>
                  <li>• Zero-waste artisan cutting techniques</li>
                  <li>• Carbon-neutral shipping via offsets</li>
                  <li>• Recycled packaging from 90% post-consumer materials</li>
                </ul>
              </div>
              <div className="bg-green-50 p-8 rounded-3xl">
                <h3 className="font-black text-xl mb-4 flex items-center gap-2">
                  Impact Stats
                </h3>
                <div className="space-y-3 text-sm">
                  <p>
                    🌱 <span className="font-black">500+ trees saved</span>{" "}
                    through organic fibers
                  </p>
                  <p>
                    ♻️ <span className="font-black">98% less water</span> vs
                    conventional textile
                  </p>
                  <p>
                    🔄 <span className="font-black">1.2 tons CO2</span> offset
                    annually
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={() => setActivePage("home")}
              className="text-pink-600 font-black underline"
            >
              Back to Home
            </button>
          </div>
        )}

        {/* Cookie Settings Page */}
        {activePage === "cookies" && (
          <div className="max-w-2xl mx-auto py-10 space-y-8">
            <h1 className="text-4xl font-black">COOKIE SETTINGS</h1>
            <div className="bg-gray-50 p-8 rounded-3xl space-y-6">
              <div>
                <h3 className="font-black text-lg mb-3 flex items-center gap-2">
                  Essential Cookies{" "}
                  <span className="text-green-600">(Always Active)</span>
                </h3>
                <p className="text-sm text-gray-600">
                  Cart functionality, login sessions, security
                </p>
              </div>
              <div>
                <h3 className="font-black text-lg mb-3 flex items-center gap-2">
                  Analytics Cookies
                </h3>
                <label className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    className="w-5 h-5 text-pink-500 rounded"
                    defaultChecked
                  />
                  <span className="text-sm">
                    Help improve site performance (Google Analytics)
                  </span>
                </label>
              </div>
              <div className="pt-6 border-t flex gap-4">
                <button className="flex-1 bg-slate-900 text-white py-3 px-6 rounded-xl font-bold hover:bg-pink-600 transition-all">
                  Save Settings
                </button>
                <button
                  onClick={() => setActivePage("home")}
                  className="flex-1 bg-gray-100 text-gray-700 py-3 px-6 rounded-xl font-bold"
                >
                  Back to Site
                </button>
              </div>
            </div>
            <p className="text-xs text-gray-500 text-center">
              Last updated: December 2025
            </p>
          </div>
        )}

        {/* About Page */}
        {activePage === "about" && (
          <div className="max-w-4xl mx-auto py-10 space-y-12">
            <div className="text-center">
              <h1 className="text-5xl font-black mb-6">
                CROCHET<span className="text-pink-500">BEEE</span>
              </h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
                Luxury handcrafted from master weavers. Sustainable, rare,
                personal.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-black mb-6">Our Story</h2>
                <p className="text-gray-600 leading-relaxed mb-8">
                  Founded in 2023, CrochetBeee bridges ancient crochet
                  traditions with modern luxury. Each piece tells a story from
                  artisan hands.
                  <br />
                  We believe that beauty is an act of patience. Every bag, cap,
                  and doll we create is a protest against fast fashion. When you
                  wear CrochetBeee, you wear 40 hours of human focus, natural
                  fibers, and the soul of a creator
                </p>
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="space-y-2">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center text-pink-600 font-black">
                      👥
                    </div>
                    <p className="text-sm font-bold">Artisans</p>
                  </div>
                  <div className="space-y-2">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center text-green-600 font-black">
                      🌍
                    </div>
                    <p className="text-sm font-bold">Countries</p>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img
                  src={backg4}
                  alt="aboutImage"
                  className="w-full h-full opacity-100 rounded-3xl p-0"
                />
                {/* <div className="aspect-[4/3] bg-gradient-to-br from-pink-500/10 to-slate-900/20 rounded-3xl p-12 flex items-center justify-center">
                </div> */}
              </div>
            </div>

            <button
              onClick={() => setActivePage("home")}
              className="mx-auto block bg-slate-900 text-white px-12 py-4 rounded-xl font-black hover:bg-pink-600 transition-all shadow-xl"
            >
              Explore Collections
            </button>
          </div>
        )}

        {/* Artisan Network Page */}
        {activePage === "artisans" && (
          <div className="max-w-6xl mx-auto py-10 space-y-12">
            <div className="text-center space-y-6">
              <h1 className="text-5xl font-black">
                ARTISAN<span className="text-pink-500"> NETWORK</span>
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Meet the master hands behind every stitch. Direct from artisan
                to collector.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Artisan 1 */}
              <div className="group bg-white p-8 rounded-3xl border border-gray-100 hover:shadow-2xl transition-all hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-r from-pink-400 to-rose-500 rounded-2xl flex items-center justify-center font-black text-white mb-6 mx-auto group-hover:scale-110 transition-transform">
                  US
                </div>
                <h3 className="font-black text-xl text-center mb-3">
                  Maria Rossi
                </h3>
                <p className="text-sm text-gray-500 text-center mb-6">
                  Master Weaver
                </p>
                <ul>
                  {/* className="text-xs text-gray-600 space-y-2" */}
                  <li>• 28 years experience</li>
                  <li>• Amalfi lace specialist</li>
                  <li>• 1,247 pieces crafted</li>
                </ul>
              </div>

              {/* Artisan 2 */}
              <div className="group bg-white p-8 rounded-3xl border border-gray-100 hover:shadow-2xl transition-all hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-2xl flex items-center justify-center font-black text-white mb-6 mx-auto group-hover:scale-110 transition-transform">
                  🇮🇳
                </div>
                <h3 className="font-black text-xl text-center mb-3">
                  Priya Patel
                </h3>
                <p className="text-sm text-gray-500 text-center mb-6">
                  Hyderabad Knot Expert
                </p>
                <ul>
                  <li>• 15 years experience</li>
                  <li>• Telugu motif specialist</li>
                  <li>• 892 pieces crafted</li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <button
                onClick={() => setActivePage("home")}
                className="bg-pink-500 text-white px-12 py-4 rounded-xl font-black hover:bg-pink-600 transition-all shadow-xl"
              >
                Shop Artisan Collections
              </button>
            </div>
          </div>
        )}

        {/* STYLE QUIZ PAGE - ADD THIS ENTIRE BLOCK */}
        {activePage === "quiz" && (
          <div className="max-w-2xl mx-auto py-20 text-center">
            <button
              onClick={() => setActivePage("home")}
              className="mb-8 p-2 hover:bg-gray-100 rounded-full"
            >
              <ChevronLeft />
            </button>
            <h1 className="text-4xl font-black mb-8">What's Your Style?</h1>
            <div className="space-y-4 max-w-md mx-auto">
              <button
                onClick={() => {
                  localStorage.setItem("userStyle", "boho");
                  setActivePage("home");
                }}
                className="w-full p-6 bg-gradient-to-r from-pink-500 to-orange-500 text-white rounded-2xl font-black text-lg shadow-xl hover:scale-105 transition-all"
              >
                🌿 Boho Artisan
              </button>
              <button
                onClick={() => {
                  localStorage.setItem("userStyle", "minimal");
                  setActivePage("home");
                }}
                className="w-full p-6 bg-gradient-to-r from-slate-900 to-gray-800 text-white rounded-2xl font-black text-lg shadow-xl hover:scale-105 transition-all"
              >
                ✨ Modern Minimal
              </button>
            </div>
          </div>
        )}
      </main>

      {/* FOOTER */}
      <footer className="bg-slate-900 text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 py-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-20">
            <div className="col-span-2 md:col-span-1 space-y-6">
              <div className="text-2xl font-black tracking-tighter">
                CROCHET<span className="text-pink-500">BEEE</span>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed max-w-xs uppercase tracking-widest font-bold">
                The global authority on hand-knotted luxury weaving.
              </p>
              <div className="flex gap-4">
                <Instagram
                  className="text-gray-500 hover:text-white cursor-pointer transition-colors"
                  size={20}
                />
                <Twitter
                  className="text-gray-500 hover:text-white cursor-pointer transition-colors"
                  size={20}
                />
                <Facebook
                  className="text-gray-500 hover:text-white cursor-pointer transition-colors"
                  size={20}
                />
              </div>
            </div>
            <div className="space-y-4">
              <h4 className="font-black text-sm uppercase tracking-widest">
                Company
              </h4>
              <ul className="space-y-2 text-xs text-gray-400 font-bold uppercase tracking-wider">
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => navigate("home")}
                >
                  Our Collections
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("about")}
                >
                  About the Page
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("artisans")}
                >
                  Artisan Network
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("heritage")}
                >
                  Heritage Lab
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h4 className="font-black text-sm uppercase tracking-widest">
                Support
              </h4>
              <ul className="space-y-2 text-xs text-gray-400 font-bold uppercase tracking-wider">
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => navigate("help")}
                >
                  Customer Service
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => navigate("shipping")}
                >
                  Shipping Policies
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => navigate("privacy")}
                >
                  Privacy Policy
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => navigate("help")}
                >
                  FAQ & Help
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h4 className="font-black text-sm uppercase tracking-widest">
                Legal
              </h4>
              <ul className="space-y-2 text-xs text-gray-400 font-bold uppercase tracking-wider">
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("terms")}
                >
                  Terms of Service
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("sustainability")}
                >
                  Sustainability
                </li>
                <li
                  className="hover:text-pink-500 cursor-pointer"
                  onClick={() => setActivePage("cookies")}
                >
                  Cookie Settings
                </li>
              </ul>
            </div>
          </div>
          <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">
              © 2025 CrochetBeee . All Rights Reserved.
            </p>
            {/* <div className="flex gap-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="w-10 h-6 bg-white/5 rounded"></div>
              ))}
            </div> */}
          </div>
        </div>
      </footer>
    </div>
  );
}
